module.exports = __webpack_public_path__ + "static/img/loading.2e0b6d1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/common/loading.gif
// module id = eoL9
// module chunks = 0 1 14